import {
  checkbox,
  customTemplate,
  DynamicFormField,
  fieldGroup,
  FormFieldsCustomizer,
  number,
  repeatTable,
  select,
  text,
} from '@kinet-open-network/client/core/forms/ui';
import { selectLazyStockItems } from '@kinet-open-network/client/stock-items/data-access';
import { StockMoveItem } from '@kinet-open-network/client/stock-moves/data-access';
import { StockMoveGeneralTabComponent } from '@kinet-open-network/client/stock-moves/feature/detail';
import {
  createEnumList,
  StockMoveItemType,
  stockMoveItemTypeOptions,
} from '@kinet-open-network/shared/data-access/model';
import { IAppStockItem } from '@kinet-open-network/shared/data-access/model-pbgas';
import { firstValueFrom } from 'rxjs';

export const stockMoveFieldsCustomizer: FormFieldsCustomizer<
  StockMoveGeneralTabComponent
> = (fields, context) => {
  const itemsField = repeatTable('items')
    .className('col-span-full mb-8')
    .props({
      tableClass: 'w-full',
      buttonsDisabled: context.disabled(),
      newItem: () =>
        new StockMoveItem({
          qty: 1,
          type: context.store.model()?.type ?? StockMoveItemType.Transfer,
        }),
      cellClass: {
        type: 'w-40',
        qtyFrom: 'w-40',
        qtyTo: 'w-40',
        actions: 'w-8',
      },
      additionalButtons: [
        {
          icon: 'pi pi-camera',
          command: () => context.store.setCameraScannerVisible(true),
          size: 'small',
          outlined: true,
          disabled: context.disabled(),
        },
      ],
    })
    .array(
      fieldGroup().fieldGroup([
        selectLazyStockItems(context.stockItemsService, {
          label: 'Skladová karta',
          forceFilters: '',
        })
          .props({
            autoOpen: true,
            change: async (
              field: DynamicFormField,
              event: { value: string },
            ) => {
              if (event?.value) {
                const stockItem = await firstValueFrom<IAppStockItem>(
                  context.stockItemsService.findOne(event.value),
                );
                const items = context.store.model()?.items?.map((i: any) => {
                  if (i.stockItemId === event.value) {
                    i.stockItem = stockItem;
                    if (stockItem?.box) {
                      i.isFull = null;
                    }
                  }
                  return i;
                });
                context.onFormChange({ items });
              }
            },
          })
          .wrappers([])
          .required(),

        select('type', 'Typ')
          .options(createEnumList(stockMoveItemTypeOptions))
          .wrappers([])
          .required(),
        number('qty', 'Počet', -1000000).wrappers([]).required(),
        text('qtyFrom', 'Stav skladu od').wrappers([]).disabled(),
        text('qtyTo', 'Stav skladu do').wrappers([]).disabled(),
        checkbox('isFull', 'Plná')
          .className('grid justify-center')
          .wrappers([])
          .disabled(
            'model?.stockItem?.type===2 || model?.stockItem?.box || formState.readonly',
          ),
        checkbox('isSell', 'Predaj')
          .className('grid justify-center')
          .wrappers([]),
        checkbox('isComplaint', 'Reklamácia')
          .className('grid justify-center')
          .wrappers([]),
        customTemplate('actions', context.itemActionsTemplate$).wrappers([]),
      ]),
    )
    .build();
  return fields.map((f) => {
    if (f.key === 'items') {
      return itemsField;
    }
    if (f.fieldGroup) {
      f.fieldGroup = f.fieldGroup.map((fg) => {
        if (fg.key === 'items') {
          return itemsField;
        }
        return fg;
      });
    }
    return f;
  });
};
